<template>
  <div id="header-links" class="hidden xl:flex relative ml-auto items-baseline gap-4">
    <router-link
      v-if="!isSettingViewOnly"
      :to="{ name: 'reservationsDashboard' }"
      id="venue-dashboard"
      class="link text-fg-link-primary block text-base font-normal"
    >
      Dashboard
    </router-link>
    <router-link
      v-if="settingStore.flagEnabled(FeatureFlag.CONTINUOUS_SERVICE)"
      :to="{ name: CS_DATE_ROUTE_NAMES.ROOT }"
      id="continuous-service"
      class="link text-fg-link-primary block text-base font-normal"
    >
      Continuous Service
    </router-link>
    <PerformanceToolsLink
      v-if="!isSettingViewOnly"
      id="venue-performance-tools"
      class="link text-fg-link-primary block text-base font-normal"
    >
      Performance Tools
    </PerformanceToolsLink>
    <router-link
      v-if="!isSettingViewOnly"
      :to="{ name: RESIDENCY_ROUTE_NAMES.LIST }"
      id="venue-residencies"
      class="link text-fg-link-primary block text-base font-normal"
    >
      Residencies
    </router-link>
    <router-link
      v-if="!isSettingViewOnly"
      :to="{ name: SHOW_ROUTE_NAMES.LIST }"
      id="venue-shows"
      class="link text-fg-link-primary block text-base font-normal"
    >
      Shows
    </router-link>
    <template v-if="isOwner">
      <router-link
        v-if="!isSettingViewOnly"
        :to="{ name: MAILCHIMP_ROUTE_NAMES.TEMPLATE_EDIT }"
        id="mailchimp-template-edit"
        class="link text-fg-link-primary block text-base font-normal"
      >
        Marketing
      </router-link>
      <router-link
        v-if="!isSettingViewOnly"
        :to="{ name: 'reportsOverview' }"
        id="venue-reports"
        class="link text-fg-link-primary block text-base font-normal"
      >
        Reports
      </router-link>
    </template>
    <VenueSearchMenu class="mr-4" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { CS_DATE_ROUTE_NAMES } from '@/modules/csDate/constants/CSDateRouteNames'
import { MAILCHIMP_ROUTE_NAMES } from '@/modules/mailchimp/constants/MailchimpRouteNames'
import PerformanceToolsLink from '@/modules/performance/components/atoms/PerformanceToolsLink.vue'
import { RESIDENCY_ROUTE_NAMES } from '@/modules/residency/constants/ResidencyRouteNames'
import { SHOW_ROUTE_NAMES } from '@/modules/show/constants/ShowRouteName'
import VenueSearchMenu from '@/modules/venueUi/components/organisms/VenueSearchMenu.vue'
import { useSettingStore } from '@/stores/setting'
import { useUserStore } from '@/stores/user'

import { FeatureFlag } from '@generated/types'

const settingStore = useSettingStore()
const { isSettingViewOnly } = storeToRefs(settingStore)

const userStore = useUserStore()
const { isOwner } = storeToRefs(userStore)
</script>
